export default defineNuxtRouteMiddleware(() => {
  const user = useSupabaseUser()

  const allowedUsers = [
    'alex.t.murray@gmail.com',
    'alex@drumrudiments.app'
  ]

  if (!user.value || !allowedUsers.includes(user.value.email)) {
    return navigateTo('/')
  }

})